//const domain = "https://apiv2.ckhealthplus.com/api";
const domain = "https://otto_api.flexondata.com.my/api";

//user
export const register = `${domain}/api/users`;
export const getToken = `${domain}/Authentication/auth`;
export const signIn = `${domain}/Authentication/signin`;
export const refreshToken = `${domain}/Authentication/refresh`;
export const logout = `${domain}/api/users/logout`;
export const getProfileDetail = `${domain}/member/get-member-by-id`;
export const forgetPassword = `${domain}/Login/forgot-password-ecom`;
export const verifyToken = `${domain}/Login/verify-forgot-password-token`;
export const resetPassword = `${domain}/Login/update-member-password`;

export const getBankInformation = `${domain}/member/get-member-bank-by-memberid`;

export const getMemberByUsername = `${domain}/member/get-member-by-username`;
export const changePassword = `${domain}/member/update-own-password`;

export const changeSecurityPassword = `${domain}/member/update-own-security-password`;

//membership
export const getMemberById = `${domain}/Member/get-member-by-id`;
export const sponsorGenealogy = `${domain}/Member/report-member-network`;
export const getPlacementGenealogy = `${domain}/Member/member-binary-tree`;
export const getPlacementGenealogyInfo = `${domain}/Member/get-member-binary-details`;
export const registerMember = `${domain}/Member/add-member`;

export const updateBankInfo = `${domain}/member/update-member-bank`;

export const updateProfileInfo = `${domain}/member/update-member`;

//annoucement
export const getAnnoucement = `${domain}/Announcement/report`;

//resource
export const getFolder = `${domain}/Resources/report-resources-folder`;
export const getFile = `${domain}/Resources/report-resources-file`;

//address
export const getAddressByMemberId = `${domain}/Member/get-member-address-by-memberid`;
export const getAddressById = `${domain}/Member/get-member-address-by-id`;
export const addAddress = `${domain}/Member/add-member-address`;
export const updateAddress = `${domain}/Member/update-member-address`;
export const deleteAddress = `${domain}/Member/delete-member-address`;

// Global
export const getState = `${domain}/Parameter/get-state-by-countryid?countryId=1`;
export const getCity = `${domain}/Parameter/get-city-by-stateid`;
export const encryptPassword = `${domain}/Parameter/encrypt`;
export const getBankList = `${domain}/parameter/get-banks-by-countryid/?countryId=1`;

export const getSettingList = `${domain}/setting/get-setting-company-fees`;

export const getBranchList = `${domain}/inventory/get-pickup-branch`;

export const fileUpload = `${domain}/fileUpload/upload-image`;
export const getBankAccount = `${domain}/setting/get-setting-company-bank`;

export const registerMemberList = `${domain}/member/get-no-ranking-member-by-memberid`;

//product
export const getProducts = `${domain}/Product/get-sales-product`;
export const getProductDetail = `${domain}/product/get-product-by-id`;

// Wallet
export const getWalletTypeList = `${domain}/parameter/get-wallet-type`;
export const getAllWalletBalance = `${domain}/wallet/get-all-wallet`;
export const getBonusSummary = `${domain}/reward/report-reward-summary`;

export const getWalletBalance = `${domain}/wallet/get-balance`;

export const getTransactionHistory = `${domain}/wallet/report-statement`;
export const getWithdrawalHistory = `${domain}/wallet/report-withdraw`;
export const convertWallet = `${domain}/wallet/add-convert`;
export const withdrawalWallet = `${domain}/wallet/add-withdraw`;
export const transferWallet = `${domain}/wallet/add-transfer`;
export const getBonusTransactionHistory = `${domain}/reward/report-reward-statement`;

//Sales
export const addToCart = `${domain}/sales/add-shopping-cart`;
export const getCartList = `${domain}/sales/get-shopping-cart-by-memberid`;
export const updateCartProductQuantity = `${domain}/sales/update-shopping-cart-quantity`;
export const addSales = `${domain}/sales/add-sales`;

export const addRegisterSales = `${domain}/sales/add-registration-sales`;

export const getOrderList = `${domain}/sales/report-sales`;

export const getSalesDetail = `${domain}/sales/get-sales-by-invoiceno`;
